import { useState, useEffect } from "react";
import {
  X,
  Download,
} from "lucide-react";
import { isPWA, isMobile } from "../lib/config";

export const InstallBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed || isPWA()) return;

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    
    if (isMobile() && !isPWA()) {
      setTimeout(() => setShowBanner(true), 5000);
    }

    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowBanner(false);
      }
      setDeferredPrompt(null);
    } else {
      window.open('/install.html', '_blank');
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 lg:bottom-4 left-4 right-4 lg:left-auto lg:right-4 lg:w-80 bg-gradient-to-r from-purple-600 to-cyan-500 rounded-2xl p-4 shadow-xl z-50">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-white">Install DigitalMe</h3>
          <p className="text-white/80 text-sm mt-1">Add to your home screen for a better experience</p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={handleInstall}
              className="px-4 py-2 bg-white text-purple-700 rounded-lg text-sm font-medium hover:bg-gray-100 transition"
            >
              Install
            </button>
            <button
              onClick={handleDismiss}
              className="px-4 py-2 text-white/80 hover:text-white text-sm font-medium transition"
            >
              Not Now
            </button>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-white/60 hover:text-white">
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

// Mobile Bottom Navigation
